import { AxiosPromise } from 'axios';
import { http } from 'services';

export type ReferralStatus = 'pending' | 'rewarded' | 'reversed';

export interface Referral {
  id: string;
  referredOrgId: string;
  code: string;
  status: ReferralStatus;
  welcomeCoins: number;
  referrerCoins: number;
  createdAt?: string;
}

// The active org's shareable referral code + signup link.
export const GetReferralCode = (): AxiosPromise<{ code: string; link: string }> =>
  http.request.get('/api/referrals/code');

// Referrals made by the active org.
export const GetReferrals = (): AxiosPromise<Referral[]> => http.request.get('/api/referrals');
